import { LoginService } from './../login.service';
import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterLink } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { AuthTenantService } from '../auth-tenant.service'
import { LockService } from '../../services/lock.service';
import { ToastrService } from 'ngx-toastr';
import {
    trigger,
    transition,
    style,
    animate
} from '@angular/animations';
import { finalize } from 'rxjs';
type Role = {
    id: number;
    name: string;
    description: string;
    roleLevel: string; // note: comes as a string
    disabled: boolean;
};

type AuthenticatedUser = {
    username: string;
    userId: number;
    base64EncodedAuthenticationKey: string;
    authenticated: boolean;
    displayName: string;
    email: string;
    roles: Role[];
    permissions: unknown[]; // empty array, type not specified
    shouldRenewPassword: boolean;
    userType: number;
    isTenant: boolean;
    tenantId: number;
    twoFactorAuthenticationRequired: boolean;
};
@Component({
    selector: 'app-lock-screen',
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, MatButtonModule, MatCheckboxModule, ReactiveFormsModule, CommonModule, AsyncPipe],
    templateUrl: './lock-screen.component.html',
    styleUrl: './lock-screen.component.scss'
})
export class LockScreenComponent implements OnInit {

    // isToggled
    isToggled = false;

    // Password Hide
    hide = true;
    tenant$ = this.tenantService.tenant$
    // Form
    authForm: FormGroup;
    currentUser: AuthenticatedUser | any
    unlocking = false
    constructor(
        private fb: FormBuilder,
        private router: Router,
        public themeService: CustomizerSettingsService,
        private tenantService: AuthTenantService,
        private loginService: LoginService,
        private sessionLock: LockService,
        private toaster: ToastrService

    ) {
        this.authForm = this.fb.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required]],
        });
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }
    ngOnInit(): void {
        this.getCurrentUser()
    }

    private getCurrentUser(): AuthenticatedUser | null {
        const storedUser = sessionStorage.getItem('currentUser');

        if (!storedUser) {
            this.currentUser = null;
            return null;
        }

        try {
            const user: AuthenticatedUser = JSON.parse(storedUser);
            this.currentUser = user;
            return user;
        } catch {
            this.currentUser = null;
            return null;
        }
    }
    onSubmit() {

        if (this.authForm.invalid) {
            this.authForm.markAllAsTouched()
        }
        this.unlocking = true
        const payload: { username: string, password: string } = {
            username: this.authForm.get('username')?.value,
            password: this.authForm.get('password')?.value
        }
        this.loginService.unLockScreen(payload).pipe(finalize(() => this.unlocking = false)).subscribe({
            next: (res) => {
                this.toaster.success("App unlocked sucessfully")
                setTimeout(() => {
                    this.sessionLock.unlock();
                }, 1000);

            },
            error: (err) => {
                console.log("Error :", err)
                this.toaster.error(`Failed to unlock check cridentials and try again. Error: ${err}`)
            }
        })
    }

}